var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

introHighlight();
featured();
darkPage();
footerGroup();
categoryNav();
formatLinkIcons();
// Call the function when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupFootnotes();
        randomizeCardRotation();
        logoMarquee();
        // introHighlight();
        setupNavHighlight({
            navSelector: '.blog-navbar',
            highlightSelector: '.blog-navbar-underline',
            itemSelector: '.blog-navbar-item',
            activeClass: 'is-active'
        });
        setupNavHighlight({
            navSelector: '.gh-head-menu',
            highlightSelector: '.gh-head-menu-bg',
            itemSelector: '.nav-new li a',
            activeClass: 'nav-current',
            onNavLeave: 'hide'
        });
        fitFooterSiteTitle();
        setupSmoothScroll();
        setupScrollToTop();
        handleVideoPlayback();
    });
} else {
    setupFootnotes();
    randomizeCardRotation();
    logoMarquee();
    // introHighlight();
    setupNavHighlight({
        navSelector: '.blog-navbar',
        highlightSelector: '.blog-navbar-underline',
        itemSelector: '.blog-navbar-item',
        activeClass: 'is-active'
    });
    setupNavHighlight({
        navSelector: '.gh-head-menu',
        highlightSelector: '.gh-head-menu-bg',
        itemSelector: '.nav li a',
        activeClass: 'nav-current',
        onNavLeave: 'hide'
    });
    fitFooterSiteTitle();
    setupSmoothScroll();
    setupScrollToTop();
    handleVideoPlayback();
}

window.addEventListener('scroll', introHighlight);
window.addEventListener('resize', fitFooterSiteTitle);

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function randomizeCardRotation() {
    'use strict';
    // Get all category card media elements
    const cardMediaElements = document.querySelectorAll('.category-card-media');
    
    // If no elements found, exit early
    if (!cardMediaElements.length) return;
    
    // For each element, set a random rotation
    cardMediaElements.forEach(element => {
        // Generate random number between -20 and 20, but avoid -4 to 4 range
        let randomRotation;
        do {
            randomRotation = Math.floor(Math.random() * 41) - 20; // 41 possible values from -20 to 20
        } while (randomRotation >= -4 && randomRotation <= 4);
        
        // Set the custom property on the element
        element.style.setProperty('--random-rotation', `${randomRotation}deg`);
        
        // Set a longer initial transition duration (will be overridden by CSS after animation completes)
        element.style.transition = 'transform 0.6s cubic-bezier(0.18, 0.89, 0.32, 1.28)';
        
        // Reset to CSS-defined transition after initial animation
        setTimeout(() => {
            element.style.transition = '';
        }, 800); // Match the duration above
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 16,
        loop: false,
        nav: false,
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function darkPage() {
    var isDark = body.classList.contains('tag-hash-dark') ? 'dark' : 'light';
    html.classList.add(`${isDark}-page`);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;

    const items = document.querySelectorAll(".footer-nav .nav li");
    
    if (!footerNav || !items.length) return;
    
    const groups = [];
    let index = null;

    // Process all items first
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else if (index !== null) {
            const link = item.querySelector('a');
            if (link) {
                groups[index].items.push({ text, link: link.href });
            }
        }
    });

    // Only proceed if we found groups
    if (groups.length === 0) return;

    // Create the new structure
    groups.forEach((group) => {
        const div = document.createElement('div');
        div.classList.add("footer-nav-group");
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        });
        div.append(h6, ul);
        footerNav.appendChild(div);
    });

    // Remove the old nav if we have new content
    if (groups.length > 0) {
        const oldNav = document.querySelector(".footer-nav ul.nav");
        if (oldNav && oldNav.parentNode) {  // Check if element exists and has a parent
            oldNav.remove();
        }
    }
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}

function introHighlight() {
    const textIntro = document.querySelector('.hero-intro.tag-hash-animate, .hero-intro.animate');
    if (!textIntro) return;

    const textElements = textIntro.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6, blockquote');
    const viewportHeight = window.innerHeight;
    
    // Get values from CSS variables
    const maxBlur = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--intro-blur-max'));
    const blurZoneStart = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--blur-zone-start')) / 100;
    const safeZoneHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--safe-zone-height')) / 100;
    
    // Calculate safe zone boundaries
    const safeZoneStart = blurZoneStart - safeZoneHeight; // Safe zone starts before blur zone
    const safeZoneEnd = blurZoneStart; // Safe zone ends where blur zone starts

    // Function to process markdown-style bold text and split into words
    function processTextIntoWords(text) {
        // Convert **text** to <strong>text</strong>
        const processedText = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        
        // Split by spaces but preserve HTML tags
        const parts = processedText.split(/(\s+)/);
        const words = [];
        
        parts.forEach(part => {
            if (part.trim() !== '') {
                words.push(part);
            } else if (part.match(/\s+/)) {
                // Add space to previous word if it exists
                if (words.length > 0) {
                    words[words.length - 1] += part;
                }
            }
        });
        
        return words;
    }

    // Function to process text nodes while preserving HTML structure
    function processElementIntoWords(element) {
        // Skip if element is a list container - we'll process list items instead
        if (element.tagName === 'UL' || element.tagName === 'OL') {
            const listItems = element.querySelectorAll('li');
            listItems.forEach(li => processElementIntoWords(li));
            return;
        }

        // Create a temporary container to work with the HTML
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = element.innerHTML;
        
        // Process markdown-style bold text
        tempContainer.innerHTML = tempContainer.innerHTML.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        
        // Function to recursively process text nodes
        function processTextNodes(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                if (text.trim() === '') return;
                
                // Split text into words
                const words = text.split(/(\s+)/);
                const fragment = document.createDocumentFragment();
                
                words.forEach(word => {
                    if (word.trim() !== '') {
                        const span = document.createElement('span');
                        span.className = 'word-reveal';
                        span.textContent = word;
                        fragment.appendChild(span);
                    } else if (word.match(/\s+/)) {
                        // Add whitespace to previous span if it exists
                        const lastSpan = fragment.lastElementChild;
                        if (lastSpan && lastSpan.classList.contains('word-reveal')) {
                            lastSpan.textContent += word;
                        } else {
                            // Create a span for standalone whitespace
                            const span = document.createElement('span');
                            span.className = 'word-reveal';
                            span.textContent = word;
                            fragment.appendChild(span);
                        }
                    }
                });
                
                // Replace the text node with the fragment
                node.parentNode.replaceChild(fragment, node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                // Process child nodes of elements (like <a>, <strong>, etc.)
                const childNodes = Array.from(node.childNodes);
                childNodes.forEach(child => processTextNodes(child));
            }
        }
        
        // Process all text nodes in the temporary container
        const childNodes = Array.from(tempContainer.childNodes);
        childNodes.forEach(child => processTextNodes(child));
        
        // Replace the original element content with processed content
        element.innerHTML = tempContainer.innerHTML;
    }

    // Process each text element only once
    if (!textIntro.dataset.processed) {
        textElements.forEach(element => {
            processElementIntoWords(element);
        });
        
        // Add special elements as single reveal units
        const specialElements = textIntro.querySelectorAll('.primary-author-social-links, .form-wrapper, .subscription-box, .staff-social-link, figure, .kg-button-card');
        specialElements.forEach(element => {
            element.classList.add('element-reveal');
        });
        
        textIntro.dataset.processed = 'true';
    }

    const allWords = textIntro.querySelectorAll('.word-reveal');
    const specialElements = textIntro.querySelectorAll('.element-reveal');
    const allRevealItems = [...allWords, ...specialElements];
    
    // Get values from CSS variables
    const triggerPointMultiplier = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--intro-trigger-point'));
    const revealZoneMultiplier = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--intro-reveal-zone'));
    
    const triggerPoint = viewportHeight * triggerPointMultiplier;
    const revealZone = viewportHeight * revealZoneMultiplier;

    // Check if the intro section has entered the trigger point
    const introRect = textIntro.getBoundingClientRect();
    const introHasEntered = introRect.top < triggerPoint;

    if (!introHasEntered) {
        // Before entering trigger zone - all items are grey
        allRevealItems.forEach(item => {
            item.classList.remove('word-highlighted');
            
            // Apply blur effect for items in blur zone even before trigger
            const itemRect = item.getBoundingClientRect();
            const itemTopFromViewport = itemRect.top / viewportHeight;

            if (itemTopFromViewport >= blurZoneStart) {
                // Item is in blur zone
                const blurProgress = (itemTopFromViewport - blurZoneStart) / (1 - blurZoneStart);
                const blurAmount = Math.min(blurProgress * maxBlur, maxBlur);
                item.style.filter = `blur(${blurAmount}px)`;
            } else {
                item.style.filter = 'none';
            }
        });
        return;
    }

    // Calculate how far we've scrolled into the reveal zone
    const scrollProgress = Math.max(0, (triggerPoint - introRect.top) / revealZone);
    
    // Check if any item would be revealed in the safe zone or blur zone
    let maxRevealableItems = allRevealItems.length;
    allRevealItems.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemTopFromViewport = itemRect.top / viewportHeight;
        
        // If this item is in the safe zone or blur zone, don't reveal beyond the previous item
        if (itemTopFromViewport >= safeZoneStart && index < maxRevealableItems) {
            maxRevealableItems = Math.max(0, index - 1); // Stop before this item
        }
    });
    
    // Calculate items to reveal, but not more than maxRevealableItems
    const itemsToReveal = Math.min(
        Math.floor(scrollProgress * allRevealItems.length),
        maxRevealableItems
    );

    // Apply effects to each item
    allRevealItems.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemTopFromViewport = itemRect.top / viewportHeight;

        // Handle color transition (grey to black) - item by item
        if (index <= itemsToReveal) {
            item.classList.add('word-highlighted');
        } else {
            item.classList.remove('word-highlighted');
        }

        // Handle blur effect based on position
        if (itemTopFromViewport >= blurZoneStart) {
            // Item is in blur zone
            const blurProgress = (itemTopFromViewport - blurZoneStart) / (1 - blurZoneStart);
            const blurAmount = Math.min(blurProgress * maxBlur, maxBlur);
            item.style.filter = `blur(${blurAmount}px)`;
        } else {
            // Item is not in blur zone - keep clear
            item.style.filter = 'none';
        }
    });

    // If we've scrolled past the intro section, reveal all items and remove blur
    if (introRect.bottom < viewportHeight * 0.2) {
        allRevealItems.forEach(item => {
            item.classList.add('word-highlighted');
            item.style.filter = 'none';
        });
    }
}


// function introHighlight() {
//     const textIntro = document.querySelector('.hero-intro.tag-hash-animate, .hero-intro.animate');
//     if (!textIntro) return;

//     const textElements = textIntro.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6, blockquote');
//     const viewportHeight = window.innerHeight;
    
//     // Get max blur value from CSS custom property early
//     const computedStyle = window.getComputedStyle(textIntro);
//     const maxBlurValue = parseFloat(computedStyle.getPropertyValue('--intro-blur-max')) || 20;

//     // Function to process text nodes while preserving HTML structure
//     function processElementIntoWords(element) {
//         // Skip if element is a list container - we'll process list items instead
//         if (element.tagName === 'UL' || element.tagName === 'OL') {
//             const listItems = element.querySelectorAll('li');
//             listItems.forEach(li => processElementIntoWords(li));
//             return;
//         }

//         // Create a temporary container to work with the HTML
//         const tempContainer = document.createElement('div');
//         tempContainer.innerHTML = element.innerHTML;
        
//         // Process markdown-style bold text
//         tempContainer.innerHTML = tempContainer.innerHTML.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        
//         // Function to recursively process text nodes
//         function processTextNodes(node) {
//             if (node.nodeType === Node.TEXT_NODE) {
//                 const text = node.textContent;
//                 if (text.trim() === '') return;
                
//                 // Split text into words
//                 const words = text.split(/(\s+)/);
//                 const fragment = document.createDocumentFragment();
                
//                 words.forEach(word => {
//                     if (word.trim() !== '') {
//                         const span = document.createElement('span');
//                         span.className = 'word-reveal';
//                         span.textContent = word;
//                         fragment.appendChild(span);
//                     } else if (word.match(/\s+/)) {
//                         // Add whitespace to previous span if it exists
//                         const lastSpan = fragment.lastElementChild;
//                         if (lastSpan && lastSpan.classList.contains('word-reveal')) {
//                             lastSpan.textContent += word;
//                         } else {
//                             // Create a span for standalone whitespace
//                             const span = document.createElement('span');
//                             span.className = 'word-reveal';
//                             span.textContent = word;
//                             fragment.appendChild(span);
//                         }
//                     }
//                 });
                
//                 // Replace the text node with the fragment
//                 node.parentNode.replaceChild(fragment, node);
//             } else if (node.nodeType === Node.ELEMENT_NODE) {
//                 // Process child nodes of elements (like <a>, <strong>, etc.)
//                 const childNodes = Array.from(node.childNodes);
//                 childNodes.forEach(child => processTextNodes(child));
//             }
//         }
        
//         // Process all text nodes in the temporary container
//         const childNodes = Array.from(tempContainer.childNodes);
//         childNodes.forEach(child => processTextNodes(child));
        
//         // Replace the original element content with processed content
//         element.innerHTML = tempContainer.innerHTML;
//     }

//     // Process each text element only once
//     if (!textIntro.dataset.processed) {
//         textElements.forEach(element => {
//             processElementIntoWords(element);
//         });
        
//         // Add special elements as single reveal units
//         const specialElements = textIntro.querySelectorAll('.primary-author-social-links, .form-wrapper, .subscription-box, .staff-social-link, figure');
//         specialElements.forEach(element => {
//             element.classList.add('element-reveal');
//         });
        
//         textIntro.dataset.processed = 'true';
        
//         // Force initial blur state immediately after processing
//         const allWords = textIntro.querySelectorAll('.word-reveal');
//         const allSpecialElements = textIntro.querySelectorAll('.element-reveal');
//         const allRevealItems = [...allWords, ...allSpecialElements];
        
//         allRevealItems.forEach(item => {
//             item.style.filter = `blur(${maxBlurValue}px)`;
//             item.style.opacity = '0.6';
//         });
//     }

//     const allWords = textIntro.querySelectorAll('.word-reveal');
//     const specialElements = textIntro.querySelectorAll('.element-reveal');
//     const allRevealItems = [...allWords, ...specialElements];
//     const triggerPoint = viewportHeight * 0.33; // Start revealing when 25% from top
//     const revealZone = viewportHeight * 0.6; // Zone over which words are revealed

//     // Check if the intro section has entered the trigger point
//     const introRect = textIntro.getBoundingClientRect();
//     const introHasEntered = introRect.top < triggerPoint;

//     if (!introHasEntered) {
//         // Before entering trigger zone - all items are heavily blurred
//         allRevealItems.forEach(item => {
//             item.classList.remove('word-highlighted');
//             item.style.filter = `blur(${maxBlurValue}px)`;
//             item.style.opacity = '0.6';
//         });
//         return;
//     }

//     // Calculate how far we've scrolled into the reveal zone
//     const scrollProgress = Math.max(0, (triggerPoint - introRect.top) / revealZone);
//     const itemsToReveal = Math.floor(scrollProgress * allRevealItems.length);

//     // Apply highlighting and blurring based on scroll progress
//     allRevealItems.forEach((item, index) => {
//         if (index < itemsToReveal) {
//             // Fully revealed items
//             item.classList.add('word-highlighted');
//             item.style.filter = 'blur(0px)';
//             item.style.opacity = '1';
//         } else if (index === itemsToReveal) {
//             // Currently revealing item - smooth transition
//             const itemProgress = (scrollProgress * allRevealItems.length) - itemsToReveal;
//             const blurAmount = maxBlurValue * (1 - itemProgress);
//             const opacity = 0.3 + (0.7 * itemProgress);
            
//             item.style.filter = `blur(${blurAmount}px)`;
//             item.style.opacity = opacity;
            
//             if (itemProgress > 0.5) {
//                 item.classList.add('word-highlighted');
//             } else {
//                 item.classList.remove('word-highlighted');
//             }
//         } else {
//             // Future items - use max blur value
//             item.classList.remove('word-highlighted');
//             item.style.filter = `blur(${maxBlurValue}px)`;
//             item.style.opacity = '0.6';
//         }
//     });

//     // If we've scrolled past the intro section, reveal all items
//     if (introRect.bottom < viewportHeight * 0.3) {
//         allRevealItems.forEach(item => {
//             item.classList.add('word-highlighted');
//             item.style.filter = 'blur(0px)';
//             item.style.opacity = '1';
//         });
//     }
// }

function logoMarquee() {
    'use strict';
    const marqueeContainer = document.getElementById('logo-marquee');
    if (!marqueeContainer) return;
    
    const logoContainer = marqueeContainer.querySelector('.logo-list-container');
    if (!logoContainer) return;
    
    // Clone logos to create a seamless loop
    const originalLogos = logoContainer.innerHTML;
    logoContainer.innerHTML = originalLogos + originalLogos + originalLogos;
    
    const logoItems = logoContainer.querySelectorAll('.kg-image-card');
    if (!logoItems.length) return;
    
    // Calculate total width of one set of logos
    let singleSetWidth = 0;
    const logoCount = logoItems.length / 3;
    
    for (let i = 0; i < logoCount; i++) {
        const style = window.getComputedStyle(logoItems[i]);
        const width = parseFloat(style.width);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        singleSetWidth += width + marginLeft + marginRight;
    }
    
    // Set initial position
    let currentPosition = 0;
    let animationId;
    let isPaused = false;
    let speed = window.innerWidth > 768 ? 1 : 0.5; // pixels per frame, slower on mobile
    
    // Make sure container is wide enough and positioned correctly
    logoContainer.style.width = (singleSetWidth * 3) + 'px';
    
    // Animation function with smoother reset logic
    function animate() {
        if (!isPaused) {
            currentPosition -= speed;
            
            // Reset position for seamless loop when first set is off-screen
            if (Math.abs(currentPosition) >= singleSetWidth) {
                // Reset by exactly one set width for seamless transition
                currentPosition = currentPosition + singleSetWidth;
            }
            
            logoContainer.style.transform = `translateX(${currentPosition}px)`;
        }
        animationId = requestAnimationFrame(animate);
    }
    
    // Start animation with a slight delay to ensure proper initialization
    setTimeout(() => {
        animationId = requestAnimationFrame(animate);
    }, 100);
    
    // Pause on hover
    marqueeContainer.addEventListener('mouseenter', () => {
        isPaused = true;
    });
    
    marqueeContainer.addEventListener('mouseleave', () => {
        isPaused = false;
    });
    
    // Adjust speed on window resize
    window.addEventListener('resize', () => {
        speed = window.innerWidth > 768 ? 0.4 : 0.2;
    });
    
    // Clean up on page leave
    window.addEventListener('beforeunload', () => {
        cancelAnimationFrame(animationId);
    });
}

function categoryNav() {
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

// Shared navigation highlight animation
function setupNavHighlight({navSelector, highlightSelector, itemSelector, activeClass = 'is-active', onNavLeave = null}) {
    var navbar = document.querySelector(navSelector);
    if (!navbar) return;
    var highlight = navbar.querySelector(highlightSelector);
    var items = navbar.querySelectorAll(itemSelector);
    if (!highlight || !items.length) return;

    function moveHighlightTo(element) {
        var rect = element.getBoundingClientRect();
        var navbarRect = navbar.getBoundingClientRect();
        highlight.style.left = (rect.left - navbarRect.left + navbar.scrollLeft) + 'px';
        highlight.style.width = rect.width + 'px';
    }

    // Set highlight to active item on load without transition
    var activeItem = navbar.querySelector(itemSelector + '.' + activeClass);
    if (activeItem) {
        highlight.style.transition = 'none'; // Disable transition
        moveHighlightTo(activeItem); // Position highlight without animation
        
        // Force reflow and restore transition after a small delay
        setTimeout(function() {
            highlight.style.transition = '';
        }, 50); // Small delay to ensure correct positioning
    }

    items.forEach(function(item) {
        item.addEventListener('mouseenter', function() { 
            // Don't move highlight if dropdown is open or if item is inside dropdown
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            
            // Check if item is inside a submenu dropdown
            const dropdownContainer = item.closest('.dropdown');
            if (dropdownContainer) {
                // Find the parent nav item that has the dropdown
                const parentNavItem = dropdownContainer.closest('li.has-dropdown');
                if (parentNavItem) {
                    const parentLink = parentNavItem.querySelector('a');
                    if (parentLink) {
                        moveHighlightTo(parentLink);
                        return;
                    }
                }
            }
            
            moveHighlightTo(item); 
        });
        item.addEventListener('focus', function() { 
            // Don't move highlight if dropdown is open or if item is inside dropdown
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            
            // Check if item is inside a submenu dropdown
            const dropdownContainer = item.closest('.dropdown');
            if (dropdownContainer) {
                // Find the parent nav item that has the dropdown
                const parentNavItem = dropdownContainer.closest('li.has-dropdown');
                if (parentNavItem) {
                    const parentLink = parentNavItem.querySelector('a');
                    if (parentLink) {
                        moveHighlightTo(parentLink);
                        return;
                    }
                }
            }
            
            moveHighlightTo(item); 
        });
        item.addEventListener('mouseleave', function() {
            // Don't move highlight if dropdown is open
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('blur', function() {
            // Don't move highlight if dropdown is open
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('click', function(e) {
            // Prevent transition if clicking the active item
            if (item === activeItem) {
                var prevTransition = highlight.style.transition;
                highlight.style.transition = 'none';
                moveHighlightTo(item);
                void highlight.offsetWidth; // force reflow
                highlight.style.transition = prevTransition;
            }
        });
    });

    // Reposition highlight on window resize
    window.addEventListener('resize', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });
    // Reposition highlight on navbar scroll (for horizontal scroll)
    navbar.addEventListener('scroll', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });

    // Hide highlight on nav mouseleave if requested
    if (onNavLeave === 'hide') {
        navbar.addEventListener('mouseleave', function() {
            highlight.style.opacity = '0';
            highlight.style.pointerEvents = 'none';
        });
        navbar.addEventListener('mouseenter', function() {
            highlight.style.opacity = '1';
            highlight.style.pointerEvents = 'auto';
            if (activeItem) moveHighlightTo(activeItem);
        });

        // Hide highlight when dropdown is open
        const body = document.body;
        const observer = new MutationObserver(() => {
            if (body.classList.contains('is-dropdown-open')) {
                highlight.style.opacity = '0';
                highlight.style.pointerEvents = 'none';
            }
        });
        observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    }
}

function fitFooterSiteTitle() {
    const siteTitleFooter = document.getElementById('site-title-footer');
    if (!siteTitleFooter) return;
    
    const container = siteTitleFooter.parentElement;
    if (!container) return;
    
    // Store original text if not already stored
    if (!siteTitleFooter.getAttribute('data-original-text')) {
        siteTitleFooter.setAttribute('data-original-text', siteTitleFooter.textContent.trim());
    }
    
    const originalText = siteTitleFooter.getAttribute('data-original-text');
    
    // Reset text content
    siteTitleFooter.textContent = originalText;
    
    // Get container width - use offsetWidth for more accurate measurement
    const containerWidth = container.offsetWidth;
    const textLength = originalText.length;
    
    // Calculate font size based on container width and text length
    // The longer the text, the smaller the font; the shorter, the larger
    let fontSize;
    
    if (textLength <= 5) {
        // Very short text - make it very large (like "Ghost" in screenshot)
        fontSize = containerWidth * 0.25; // 25% of container width
    } else if (textLength <= 10) {
        // Short text - make it large
        fontSize = containerWidth * 0.20; // 20% of container width
    } else if (textLength <= 15) {
        // Medium text - make it medium-sized
        fontSize = containerWidth * 0.15; // 15% of container width
    } else if (textLength <= 25) {
        // Longer text - make it smaller
        fontSize = containerWidth * 0.10; // 10% of container width
    } else {
        // Very long text - make it even smaller
        fontSize = containerWidth * 0.08; // 8% of container width
    }
    
    // Apply size limits
    const minFontSize = 24;
    const maxFontSize = Math.min(containerWidth * 0.25, 120); // Cap at 120px or 25% of width
    
    fontSize = Math.max(minFontSize, Math.min(maxFontSize, fontSize));
    
    // Apply the font size
    siteTitleFooter.style.fontSize = `${fontSize}px`;
    
    // Create a temporary span to measure if the result fits
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.fontFamily = window.getComputedStyle(siteTitleFooter).fontFamily;
    tempSpan.style.fontWeight = window.getComputedStyle(siteTitleFooter).fontWeight;
    tempSpan.style.fontSize = `${fontSize}px`;
    tempSpan.textContent = originalText;
    document.body.appendChild(tempSpan);
    
    // Check if text is too wide and adjust if needed
    if (tempSpan.offsetWidth > containerWidth * 0.98) {
        const adjustmentRatio = containerWidth * 0.98 / tempSpan.offsetWidth;
        fontSize = Math.floor(fontSize * adjustmentRatio);
        siteTitleFooter.style.fontSize = `${fontSize}px`;
    }
    
    // Clean up
    document.body.removeChild(tempSpan);
}

function formatLinkIcons() {
    'use strict';
    
    const buttons = document.querySelectorAll('a.gh-head-link, a.kg-btn, a.kg-product-card-button, a.kg-header-card-button, a.button-header, a.button-hero, a.footer-link');
    const currentDomain = window.location.hostname;

    buttons.forEach(button => {
        const url = new URL(button.href);
        const isExternal = url.hostname !== currentDomain;
        const isHeaderCardButton = button.classList.contains('kg-header-card-button');
        
        let iconSvg;
        if (isHeaderCardButton) {
            iconSvg = `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                            <path d="M5.333 14.667v2.667h16L14 24.667l1.893 1.893L26.453 16 15.893 5.44 14 7.333l7.333 7.333h-16z"></path>
                        </svg>`;
        } else {
            iconSvg = isExternal ? 
                `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
                    <path d="M7.483 22.524 9.37 24.41l11.314-11.313v10.37h2.677V8.533H8.426v2.677h10.37L7.483 22.524Z"/>
                </svg>` :
                `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                    <path d="M5.333 14.667v2.667h16L14 24.667l1.893 1.893L26.453 16 15.893 5.44 14 7.333l7.333 7.333h-16z"></path>
                </svg>`;
        }

        const iconWrapper = document.createElement('span');
        iconWrapper.classList.add('button-link-icon');
        iconWrapper.innerHTML = iconSvg;

        button.appendChild(iconWrapper);
    });
}

function setupSmoothScroll() {
    'use strict';
    
    // Only apply to pages or posts (check for common Ghost post/page elements)
    const isPostOrPage = document.querySelector('.post-content, .page-content, .ghost-content, article.post, article.page');
    if (!isPostOrPage) return;
    
    // Find all anchor links that start with #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                e.preventDefault();
                
                // Calculate offset to account for fixed headers
                const headerOffset = 20; // Adjust this value based on your header height
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}

function setupScrollToTop() {
    'use strict';
    
    const scrollToTopButtons = document.querySelectorAll('.scroll-to-top');
    
    scrollToTopButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tocElement = document.getElementById('post-feed-toc');
            
            if (tocElement) {
                const headerOffset = 20;
                const elementPosition = tocElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset * 2;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}

function handleVideoPlayback() {
    const options = {
        root: null,
        rootMargin: '2px',
        threshold: [0, 0.5, 1]  // We'll observe at 0%, 25%, and 100% visibility
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            
            if (entry.intersectionRatio >= 0.5) {
                // Load the video only when it's about to be played
                if (video.preload === 'none') {
                    video.preload = 'auto';
                }
                if (video.paused) {
                    // Only play if the video has loaded
                    if (video.readyState >= 3) {
                        video.play().catch(error => console.error('Error playing video:', error));
                    } else {
                        video.addEventListener('canplay', () => {
                            video.play().catch(error => console.error('Error playing video:', error));
                        }, { once: true });
                    }
                }
            } else if (entry.intersectionRatio === 0) {
                // The video is completely out of the viewport
                if (!video.paused) {
                    video.pause();
                }
            } else if (entry.intersectionRatio < 0.5) {
                // The video is less than 25% in the viewport
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, options);

    // Add loading handler for each video
    const videos = document.querySelectorAll('video.preload-video');
    videos.forEach(video => {
        observer.observe(video);
        
        // Add error handling
        video.addEventListener('error', (e) => {
            console.error('Video loading error:', e);
            video.style.display = 'none'; // Hide video on error, showing poster/background
        });
    });
}

pagination();